import type { IconProps } from '@/shared/ui/icons/types';

export const FlagRuIcon = (props: IconProps) => (
  <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="28" height="20" fill="#fff" />
    <rect y="6.667" width="28" height="6.667" fill="#0039a6" />
    <rect y="13.333" width="28" height="6.667" fill="#d52b1e" />
  </svg>
);
